import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { IReducerState } from 'store/main-reducer';
import { getIsOptionsLoading, getHasLoadedOptions } from 'store/modules/options/selectors';
import { actionGetOptions } from 'store/modules/options/actions';
import { LoadOptionsView } from './LoadOptions';

interface Props {
  isLoading: boolean;
  hasLoadedOptions: boolean;
  getOptions: typeof actionGetOptions;
}

const LoadOptionsController = (props: Props) => {
  const {
    isLoading,
    getOptions,
    hasLoadedOptions,
  } = props;

  useEffect(() => {
    getOptions();
  }, [getOptions]);

  return (
    <>
      <LoadOptionsView
        isLoading={isLoading}
        hasLoadedOptions={hasLoadedOptions}
      />
    </>
  );
};

const mapStateToProps = (state: IReducerState) => ({
  isLoading: getIsOptionsLoading(state),
  hasLoadedOptions: getHasLoadedOptions(state),
});

const mapDispatchToProps = {
  getOptions: actionGetOptions,
};

export const LoadOptions = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoadOptionsController);
